import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ChatBoxService {
  private readonly CHAT_END_POINT = `${environment.apiUrl}/v1/subscription-conversation`;

  constructor(private readonly http: HttpClient) { }

  public submitMessage(input: { subscriptionRequestId: string, content: string }) {
    return this.http.post(`${this.CHAT_END_POINT}/send`, input);
  }

  public markMessageAsRead(input: { subscriptionRequestId: string }) {
    return this.http.post(`${this.CHAT_END_POINT}/mark-as-read`, input);
  }

  public checkNewMessageBySubscriptionRequestId(subscriptionRequestId) {
    return this.http.get<any>(
      `${this.CHAT_END_POINT}/is-new-message/${subscriptionRequestId}`
    );
  }

  public getListMessageBySubscriptionRequestId(id) {
    return this.http.get<any>(`${this.CHAT_END_POINT}/${id}`);
  }
}
